var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target, arrow, goal, aim "
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3M16.7712 13.4994C16.1341 15.5281 14.2389 16.9996 12 16.9996C9.23858 16.9996 7 14.761 7 11.9996C7 9.76079 8.47145 7.86565 10.5 7.22852M14 10H17.1716C17.702 10 18.2107 9.78929 18.5858 9.41421L21.214 6.78603C21.3454 6.65462 21.2926 6.43085 21.1162 6.37208L18.5 5.5L17.6279 2.88375C17.5691 2.70744 17.3454 2.65462 17.214 2.78603L14.5858 5.41421C14.2107 5.78929 14 6.29799 14 6.82843V10ZM14 10L12 12",
    stroke: "#295B4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetArrow);
export default __webpack_public_path__ + "static/media/target-arrow.2ed706afdbb1bb7d2a1b672b7268535b.svg";
export { ForwardRef as ReactComponent };